import { render, staticRenderFns } from "./EligibilityTags.vue?vue&type=template&id=2820e8a8&scoped=true&"
import script from "./EligibilityTags.vue?vue&type=script&lang=js&"
export * from "./EligibilityTags.vue?vue&type=script&lang=js&"
import style0 from "./EligibilityTags.vue?vue&type=style&index=0&id=2820e8a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2820e8a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1768404630/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2820e8a8')) {
      api.createRecord('2820e8a8', component.options)
    } else {
      api.reload('2820e8a8', component.options)
    }
    module.hot.accept("./EligibilityTags.vue?vue&type=template&id=2820e8a8&scoped=true&", function () {
      api.rerender('2820e8a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/EligibilityTags.vue"
export default component.exports